import { render, staticRenderFns } from "./FormatsTestTool.vue?vue&type=template&id=9480b4d2&scoped=true&"
import script from "./FormatsTestTool.vue?vue&type=script&lang=ts&"
export * from "./FormatsTestTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatsTestTool.vue?vue&type=style&index=0&id=9480b4d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9480b4d2",
  null
  
)

export default component.exports